module.exports = __webpack_public_path__ + "static/media/Deposit.8323b701.svg";